import { compose } from 'lodash/fp';
import { connect } from 'react-redux';
import { withTheme } from 'styled-components';
import { TextKey } from '@mews-distributor/common';
import { getPaymentInputStyles } from '@optimus-web/core';
import { FONT_FACE_STYLES } from '@optimus-web/fonts';
import { localizeText } from '../../../../../modules/globalization/selectors';
import { getSelectedEnterprisePaymentGatewayPublicKey } from '../../../../../modules/paymentConfigurations/selectors';
import { pciProxy } from '../../../../../services/pciProxy';
import { DistributorThunkAction } from '../../../../../types';
import { clearPaymentCardType, clearPaymentCardValues } from '../../../slices';
import { CARD_NUMBER_FIELD_ID, CVV_FIELD_ID } from './constants';

const { init, tearDown } = pciProxy.actions;

const initPciProxyService =
    (theme: $TSFixMe): DistributorThunkAction =>
    (dispatch, getState) => {
        const state = getState();
        const options = {
            merchantId: getSelectedEnterprisePaymentGatewayPublicKey(state, {}),
            cardNumberFieldId: CARD_NUMBER_FIELD_ID,
            cardNumberAriaLabel: `${localizeText(TextKey.PaymentCardNumber)(state)}, ${localizeText(TextKey.Required)(
                state
            )}`,
            cvvFieldId: CVV_FIELD_ID,
            cvvAriaLabel: `${localizeText(TextKey.PaymentCardCVV)(state)}, ${localizeText(TextKey.Required)(state)}`,
            fieldStyles: getPaymentInputStyles(theme),
            fontFaceStyles: FONT_FACE_STYLES,
        };

        dispatch(init(options));
    };

const tearDownPciProxyService = () => (dispatch: $TSFixMe) => {
    dispatch(clearPaymentCardValues());
    dispatch(clearPaymentCardType());

    dispatch(tearDown());
};

export const inject = compose(
    withTheme,
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    connect(null, (dispatch, { theme }) => ({
        // @ts-expect-error $TSFixMeError: Argument of type '(dispatch: $TSFixMe, getState: $TSFixMe, { heapService }: $TSFixMe) => void' is not assignable to para...
        initPciProxyService: () => dispatch(initPciProxyService(theme)),
        // @ts-expect-error $TSFixMeError: Argument of type '(dispatch: $TSFixMe) => void' is not assignable to parameter of type 'Action<any>'.
        tearDownPciProxyService: () => dispatch(tearDownPciProxyService()),
    }))
);
